import { useEffect, useState } from 'react';
import { BaseSelector } from '../../domain/shared';
import { positionsRepository } from '../../infrastructure/repositories/positions/positionRepository';
import Select from 'react-select';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
}

export default function PositionSelector({ onChange, value, name }: Props) {
    const [positions, setPositions] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        positionsRepository.GetPositionsList().then((res) => {
            setIsLoading(false);
            setPositions(
                res.map((p) => ({
                    label: p.name,
                    value: p.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Cargo *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={positions}
                onChange={(e) => {
                    onChange(name, e?.value);
                }}
                value={
                    positions.find((a) => a.value === value) ?? {
                        label: `Seleccione`,
                        value: 0,
                    }
                }
            />
        </div>
    );
}
